import EarthSectionBase from "./EarthSectionBase";
import Experiences from "../../pages/Experience";
import {useTranslation} from "react-i18next";

import Ground2 from "../../images/assets/underground/UNDERGROUND_FLOOR.webp"
import Ground from "../../images/assets/underground/UNDERGROUND_FLOOR2.webp"
import Rock from "../../images/assets/underground/UNDERGROUND_ROCK.webp"

import coin from "../../images/assets/shared/R_COIN.svg";
import {useMemo} from "react";
import CollectibleCoin, {getRandomCoinHover} from "../shared/CollectibleCoin";

export default function Underground ({
    layer,
    collectedCoinIds = [],
    onCoinCollect,
    isActive = false
}){
    const { t } = useTranslation();

    const coinStyles = useMemo(
        () => [getRandomCoinHover(), getRandomCoinHover(), getRandomCoinHover()],
        []
    );

    const coins = [
        { id: "underground-coin-1", className: "underground-coin", style: coinStyles[0] },
        { id: "underground-coin-2", className: "underground-coin2", style: coinStyles[1] },
        { id: "underground-coin-3", className: "underground-coin3", style: coinStyles[2] },
    ]

    return (
        <EarthSectionBase
            id={layer.id}
            background={layer.bg}
            className={""}
        >
            <img src={Ground} alt="" className={'background-img underground-floor'} />
            <img src={Ground2} alt="" className={'background-img underground-floor2'} />
            <img src={Rock} alt="" className={'background-img underground-rock'} />
            <img src={Rock} alt="" className={'background-img underground-rock2'} />

            {coins.map((coinItem) => (
                <CollectibleCoin
                    key={coinItem.id}
                    id={coinItem.id}
                    src={coin}
                    className={`background-img coin ${coinItem.className} ${
                        collectedCoinIds.includes(coinItem.id) ? "coin-collected" : "coin-clickable"
                    }`}
                    style={coinItem.style}
                    isCollected={collectedCoinIds.includes(coinItem.id)}
                    onCollect={onCoinCollect}
                />
            ))}

            <Experiences  isActive={isActive}/>
        </EarthSectionBase>
    )
}